import Component from '../FormConfig/src/EditFormPopover'

Component.install = Vue => {
  Vue.component(Component.name, Component)
}
export default Component
